import { useMemo, useState } from 'react';
import { faAngleDown, faAngleUp, faServer } from '@fortawesome/pro-regular-svg-icons';
import useMeasure from 'react-use-measure';
import AttackBoxToTargetMachineSvg from 'src/images/svgs/attack-box-to-target-machine.svg';
import TargetMachineSvg from 'src/images/svgs/target-machine.svg';
import AttackBoxSvg from 'src/images/svgs/attackbox.svg';
import { RunningInstance } from 'src/common/interfaces/instances';
import { BREAKPOINTS } from 'src/common/constants/breakpoints';
import { RoomTask } from 'src/common/interfaces/tasks';
import { TaskType } from 'src/common/enums/task';
import { StyledAccordionSummaryIcon, StyledImage, StyledMachinesWrapper, StyledAccordionContent, StyledAccordionWrapper, StyledAccordionSummary, StyledExpandIcon, StyledAccordionSummaryRightSection, StyledAccordionSummaryIpTagsWrapper, StyledAccordionSummaryLeftSection, StyledAccordionContentWrapper } from './active-machines-information.styles';
import { Machine } from './components/machine';
import { TargetMachine } from './components/target-machine';
import { MachineIpTag } from './components/machine-ip-tag';
type ActiveMachinesInformationProps = {
  attackBoxInstance?: RunningInstance;
  targetInstance?: RunningInstance;
  roomCode: string;
  hasMultipleVMs: boolean;
  tasks?: RoomTask[];
  currentTask?: RoomTask;
  isTaskBreakdownSupported: boolean;
};
export const ActiveMachinesInformation = ({
  attackBoxInstance,
  targetInstance,
  roomCode,
  hasMultipleVMs,
  tasks,
  currentTask,
  isTaskBreakdownSupported
}: ActiveMachinesInformationProps) => {
  const [ref, {
    width
  }] = useMeasure();
  const isWide = useMemo(() => width > BREAKPOINTS.MOBILE, [width]);
  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  const getMachinesImageSource = () => {
    if (!attackBoxInstance) {
      return TargetMachineSvg;
    }
    if (!targetInstance) {
      return AttackBoxSvg;
    }
    return AttackBoxToTargetMachineSvg;
  };
  if (isTaskBreakdownSupported && currentTask && ![TaskType.VM, TaskType.THM].includes(currentTask.type)) {
    return null;
  }
  if (!targetInstance && !attackBoxInstance) {
    return null;
  }
  return <StyledAccordionWrapper $isTaskBreakdownSupported={isTaskBreakdownSupported} $isExpanded={isExpanded} ref={ref} data-sentry-element="StyledAccordionWrapper" data-sentry-component="ActiveMachinesInformation" data-sentry-source-file="active-machines-information.tsx">
      <StyledAccordionSummary $isWide={isWide} data-sentry-element="StyledAccordionSummary" data-sentry-source-file="active-machines-information.tsx">
        <StyledAccordionSummaryLeftSection data-sentry-element="StyledAccordionSummaryLeftSection" data-sentry-source-file="active-machines-information.tsx">
          <span style={{
          flexGrow: 1
        }}>
            <StyledAccordionSummaryIcon icon={faServer} data-sentry-element="StyledAccordionSummaryIcon" data-sentry-source-file="active-machines-information.tsx" />
            Active machines information
          </span>
          <StyledAccordionSummaryIpTagsWrapper data-sentry-element="StyledAccordionSummaryIpTagsWrapper" data-sentry-source-file="active-machines-information.tsx">
            {attackBoxInstance && <MachineIpTag variant="attackbox" instance={attackBoxInstance} hide={isExpanded} />}
            {targetInstance && <MachineIpTag variant="target" instance={targetInstance} hide={isExpanded} />}
          </StyledAccordionSummaryIpTagsWrapper>
        </StyledAccordionSummaryLeftSection>
        <StyledAccordionSummaryRightSection data-sentry-element="StyledAccordionSummaryRightSection" data-sentry-source-file="active-machines-information.tsx">
          <StyledExpandIcon icon={isExpanded ? faAngleUp : faAngleDown} onClick={() => setIsExpanded(!isExpanded)} role="button" aria-expanded={isExpanded} data-sentry-element="StyledExpandIcon" data-sentry-source-file="active-machines-information.tsx" />
        </StyledAccordionSummaryRightSection>
      </StyledAccordionSummary>
      <StyledAccordionContentWrapper $isExpanded={isExpanded} data-sentry-element="StyledAccordionContentWrapper" data-sentry-source-file="active-machines-information.tsx">
        <StyledAccordionContent $isExpanded={isExpanded} $isWide={isWide} data-sentry-element="StyledAccordionContent" data-sentry-source-file="active-machines-information.tsx">
          <StyledImage src={getMachinesImageSource()} $isWide={isWide} data-sentry-element="StyledImage" data-sentry-source-file="active-machines-information.tsx" />
          <StyledMachinesWrapper data-sentry-element="StyledMachinesWrapper" data-sentry-source-file="active-machines-information.tsx">
            {attackBoxInstance && <Machine variant="attackbox" ipAddress={(attackBoxInstance.remote.privateIP as string)} runningInstance={attackBoxInstance} roomCode={roomCode} />}
            {targetInstance && <TargetMachine instance={targetInstance} roomCode={roomCode} hasMultipleVMs={hasMultipleVMs} tasks={tasks} />}
          </StyledMachinesWrapper>
        </StyledAccordionContent>
      </StyledAccordionContentWrapper>
    </StyledAccordionWrapper>;
};